import React, { useState, useEffect } from 'react';
import { getDatabase, ref, child, get } from 'firebase/database';
import { auth } from '../firebase.config';
import Sidebar from '../component/Sidebar';
import AddTagsInput from '../Components/adminDashboard/components/addtag';

const UserTable = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const database = getDatabase();
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      const usersData = snapshot.val();

      if (usersData) {
        const usersList = Object.entries(usersData).map(([uid, userData], index) => ({
          serialNo: index + 1,
          name: userData.name,
          role: userData.role,
          email: userData.email || auth.currentUser.email,
          uid,
        }));
        setUsers(usersList);
      }
    };

    fetchUsers();
  }, []);

  return (
<>
<div className="background-container">  
    <div className="flex relative dark:bg-main-dark-bg">
        {/* Container for settings button */}
        <div className="fixed top-4 right-4 z-50">
          {/* Settings button content */}
        </div>

        {/* Sidebar */}
        <div className="w-72 fixed sidebar  bg-opacity-30 backdrop-blur-sm dark:bg-main-bg bg-main-bg min-h-screen">
        <Sidebar />
        </div>

        <div className="ml-72 flex-1 dark:bg-main-dark-bg bg-main-bg min-h-screen pl-4">
          {/* Here is main content */}
    <div className="container mx-auto py-8  ">
      <h2 className="text-2xl font-bold mb-4 ">Existing Users</h2>
      <div className="overflow-x-auto">
        <table className="w-full bg-white rounded-lg shadow-md">
          <thead>
            <tr className="bg-gray-200 text-gray-700">
              <th className="py-3 px-4 text-left">Serial No.</th>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-left">Role</th>
              <th className="py-3 px-4 text-left">Email</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.uid} className="hover:bg-gray-100">
                <td className="py-3 px-4 border-b border-gray-300">{user.serialNo}</td>
                <td className="py-3 px-4 border-b border-gray-300">{user.name}</td>
                <td className="py-3 px-4 border-b border-gray-300">{user.role}</td>
                <td className="py-3 px-4 border-b border-gray-300">{user.email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      
      </div>
    </div>
    </div>
    </div>
    </div>
    </>
  );
};

export default UserTable;